
function isDeployedEnv() {
  return ['production', 'staging'].includes(process.env.NODE_ENV);
}

export {
  isDeployedEnv,
};
